import React from 'react';
import img from '../../../assets/Icons/black.pg.avif';
import { IoMdAddCircleOutline } from 'react-icons/io';

const DashboardNewProc = () => {
  return (
    <>
      <div className="image bg-black h-[10vh] flex items-center justify-center rounded-xl ml-3 text-white">
        <h1 className="font-bold text-3xl">Welcome to Ohm Hub Dashboard</h1>
      </div>

      {/* <div
        className="image bg-black h-[19vh] rounded-xl ml-3 relative flex place-content-center text-center"
        style={{ width: "100%" }}
      > */}
      {/* <img
          style={{ height: "100%", width: "100%", borderRadius: "12px" }}
          src={img}
          alt="backgrountimage"
        /> */}
      {/* <div className="text text-white absolute top-6 left-20 flex">
          <h1 className="font-bold text-3xl">Welcome to Ohm Hub Dashboard</h1> */}
      {/* <div className="smalltxt m-2 text-lg">
            to your new Dashboard the heartbeat of your bussiness insights!
            we're exited to embark on this journey of streamline data
            visualization and enhanced decision-making with you
          </div> */}
      {/* <div
            className="procedure-btn flex absolute top-12 right-10 rounded-xl"
            style={{ backgroundColor: " #fe104d", border: "1px solid white" }}
          >
            <div className="svg m-1 text-2xl">
              <IoMdAddCircleOutline />{" "}
            </div>
            <div className="btn-text text-base m-1">Add Procedure</div>
          </div> */}
      {/* </div>
      </div> */}
    </>
  );
};

export default DashboardNewProc;
